var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.loaded && _vm.despacho !== null && _vm.active === 0
        ? _c(
            "div",
            [
              _c("analisar-validar-processo-ba", {
                ref: "formularioCertidaoArea",
                attrs: {
                  responseAnalise: _vm.responseAnalise,
                  processo: _vm.processo,
                  idProcesso: _vm.idProcesso,
                  acaoCaixa: _vm.acaoCaixa,
                  regras: _vm.regras
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.despacho !== null && _vm.active === 1
        ? _c(
            "div",
            { staticClass: "analise" },
            [
              _vm.despacho.processo !== null
                ? _c(
                    "app-analise-header",
                    {
                      attrs: {
                        "id-processo": _vm.despacho.processo.id,
                        "numero-processo": _vm.despacho.processo.numeroProcesso,
                        statusProcesso: _vm.despacho.processo.status,
                        "titulo-analise": "Emissão de Certidão de Área",
                        tipo:
                          typeof _vm.despacho.processo.tipo === "object"
                            ? _vm.despacho.processo.tipo.codigo
                            : _vm.despacho.processo.tipo,
                        numeroProtocolo: _vm.despacho.processo.numeroProtocolo,
                        "show-separate": true,
                        "show-messages": true,
                        opcoesHeader: true,
                        btnSolicitarInformacao: true,
                        idDespacho: _vm.despacho.id
                      }
                    },
                    [
                      _c(
                        "template",
                        { slot: "separate" },
                        [
                          _c(
                            "el-card",
                            {
                              staticClass: "card-collapse",
                              attrs: { shadow: "hover" }
                            },
                            [
                              _vm.dadosCadastro
                                ? _c("app-despachos", {
                                    attrs: {
                                      idProcesso: _vm.idProcesso,
                                      data: _vm.dadosCadastro
                                    },
                                    on: { getDownload: _vm.getDownload }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "template",
                        { slot: "analise" },
                        [
                          _c(
                            "el-steps",
                            {
                              staticClass: "extra-margin-top-bottom",
                              attrs: {
                                active: _vm.active,
                                "finish-status": "success",
                                simple: "simple"
                              }
                            },
                            [
                              _c("el-step", {
                                attrs: { title: "Informar dados" }
                              }),
                              _c("el-step", {
                                attrs: { title: "Confirmar dados" }
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            [
                              _c(
                                "el-card",
                                {
                                  staticClass: "card-collapse",
                                  attrs: { shadow: "hover" }
                                },
                                [
                                  _vm.despacho
                                    ? _c("app-formulario-certidao-area", {
                                        ref: "formulario",
                                        attrs: {
                                          despacho: _vm.responseAnalise.despacho
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    2
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm.active === 2 && _vm.despacho !== null
        ? _c(
            "div",
            [
              _vm.bytes
                ? _c("app-pdf-viewer", { attrs: { bytes: _vm.bytes } })
                : _vm._e(),
              _vm.despacho.acao === "RETORNO.SISTEMA.ANTERIOR"
                ? _c(
                    "el-row",
                    [
                      _c("validation-provider", {
                        attrs: { rules: "required" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c("app-label", {
                                    staticClass: "input-text-editor",
                                    attrs: { label: "Despacho" }
                                  }),
                                  _c("app-editor-texto", {
                                    ref: "editorTexto",
                                    staticClass: "input",
                                    class: { erro: errors.length },
                                    on: { onTextChange: _vm.onTextChange },
                                    model: {
                                      value: _vm.despacho.textoDespacho,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.despacho,
                                          "textoDespacho",
                                          $$v
                                        )
                                      },
                                      expression: "despacho.textoDespacho"
                                    }
                                  }),
                                  errors.length
                                    ? _c("span", { staticClass: "help erro" }, [
                                        _vm._v(_vm._s(errors[0]))
                                      ])
                                    : _vm._e()
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          2913707364
                        )
                      }),
                      _c("app-anexo", {
                        attrs: {
                          id: "upload-anexo-despacho",
                          files: _vm.despacho.documentos,
                          tipoExibir: "ANEXO_ANALISE"
                        },
                        on: {
                          uploadFile: _vm.uploadFile,
                          removeFile: _vm.removeFile,
                          downloadDocumentoCadastro:
                            _vm.downloadDocumentoCadastro
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "validation-observer",
                {
                  ref: "validationTitulo",
                  staticClass: "flex-around",
                  attrs: { tag: "div" }
                },
                [
                  _c("app-radios-tramitacao", {
                    attrs: {
                      radios: _vm.acoesRadio,
                      isDecisao: false,
                      radioInicial: _vm.despacho.acao
                    },
                    on: { changeRadio: _vm.changeRadio }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c("app-buttons-cadastro", {
        attrs: {
          isUltimoPasso: _vm.active === 2,
          isPrimeiroPasso: _vm.active === 0,
          showButtonSalvar: [0, 1].includes(_vm.active),
          showButtonDownload: [2].includes(_vm.active),
          showButtonCancelar: [0].includes(_vm.active),
          showButtonFinalizar: [2].includes(_vm.active),
          showButtonProximo: [0, 1].includes(_vm.active)
        },
        on: {
          proximo: _vm.proximo,
          finalizar: _vm.finalizar,
          cancelar: _vm.cancelar,
          salvar: _vm.salvarCertidaoArea,
          download: _vm.downloadPdf,
          voltar: _vm.voltar
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-17f322ba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17f322ba","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/EmitirCertidaoArea.vue
// module id = null
// module chunks = 